type Props = {
  isOpened?: boolean;
};

export const K1EnvelopeIcon = ({ isOpened }: Props) => {
  if (isOpened) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="38"
        height="41"
        viewBox="0 0 38 41"
        fill="none"
        aria-hidden
      >
        <rect
          x="2"
          y="16.4238"
          width="33"
          height="21"
          rx="3"
          fill="#C7C7C7"
          stroke="#777677"
          strokeWidth="2"
        />
        <path
          d="M17.8811 24.9114L4.2662 35.6383C3.52076 36.2257 3.93607 37.4238 4.88507 37.4238H32.1149C33.0639 37.4238
          33.4792 36.2257 32.7338 35.6383L19.1189 24.9114C18.7559 24.6254 18.2441 24.6254 17.8811 24.9114Z"
          fill="white"
          stroke="#777677"
          strokeWidth="2"
        />
        <path
          d="M18.9965 30.538L33.0512 18.0449C34.0821 17.1286 33.434 15.4238 32.0547 15.4238L3.9453 15.4238C2.56603
          15.4238 1.91787 17.1286 2.94875 18.0449L17.0035 30.538C17.5718 31.0432 18.4282 31.0432 18.9965 30.538Z"
          fill="white"
          stroke="#777677"
          strokeWidth="2"
        />
        <mask
          id="path-4-outside-1_6520_14119"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0.5"
          width="38"
          height="40"
          fill="black"
        >
          <rect fill="white" y="0.5" width="38" height="40" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.67667 13.7888L17.103 4.09373C18.036 3.30209 19.4049 3.30209 20.3379 4.09373L31.7642 13.7888C32.0236
             14.0089 32.2224 14.2589 32.3654 14.5252C33.9022 15.0833 35 16.5565 35 18.2861V33.2861C35 35.4953 33.2091
             37.2861 31 37.2861H7C4.79086 37.2861 3 35.4953 3 33.2861V18.2861C3 16.8365 3.77112 15.567 4.92554
             14.8654C5.06351 14.4722 5.30922 14.1006 5.67667 13.7888Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.67667 13.7888L17.103 4.09373C18.036 3.30209 19.4049 3.30209 20.3379 4.09373L31.7642 13.7888C32.0236
           14.0089 32.2224 14.2589 32.3654 14.5252C33.9022 15.0833 35 16.5565 35 18.2861V33.2861C35 35.4953 33.2091
            37.2861 31 37.2861H7C4.79086 37.2861 3 35.4953 3 33.2861V18.2861C3 16.8365 3.77112 15.567 4.92554
            14.8654C5.06351 14.4722 5.30922 14.1006 5.67667 13.7888Z"
          fill="#C9EF93"
        />
        <path
          d="M17.103 4.09373L19.0439 6.38125L19.0439 6.38125L17.103 4.09373ZM5.67667 13.7888L7.6176 16.0763L7.6176
           16.0763L5.67667 13.7888ZM20.3379 4.09373L22.2788 1.8062V1.8062L20.3379 4.09373ZM31.7642 13.7888L29.8233
           16.0763V16.0763L31.7642 13.7888ZM32.3654 14.5252L29.7222 15.9442L30.2642 16.9539L31.3414 17.3451L32.3654
           14.5252ZM4.92554 14.8654L6.48359 17.4291L7.401 16.8716L7.75639 15.8585L4.92554 14.8654ZM15.1621
           1.8062L3.73574 11.5013L7.6176 16.0763L19.0439 6.38125L15.1621 1.8062ZM22.2788 1.8062C20.2262 0.0646029
           17.2147 0.0645974 15.1621 1.8062L19.0439 6.38125C18.8573 6.53958 18.5835 6.53958 18.3969 6.38126L22.2788
           1.8062ZM33.7051 11.5013L22.2788 1.8062L18.3969 6.38125L29.8233 16.0763L33.7051 11.5013ZM35.0086
           13.1062C34.6851 12.5037 34.2464 11.9605 33.7051 11.5013L29.8233 16.0763C29.8009 16.0573 29.7597 16.014
           29.7222 15.9442L35.0086 13.1062ZM38 18.2861C38 15.2546 36.0744 12.6804 33.3893 11.7054L31.3414 17.3451C31.73
           17.4862 32 17.8584 32 18.2861H38ZM38 33.2861V18.2861H32V33.2861H38ZM31 40.2861C34.866 40.2861 38 37.1521 38
           33.2861H32C32 33.8384 31.5523 34.2861 31 34.2861V40.2861ZM7 40.2861H31V34.2861H7V40.2861ZM0 33.2861C0
           37.1521 3.13401 40.2861 7 40.2861V34.2861C6.44772 34.2861 6 33.8384 6 33.2861H0ZM0
           18.2861V33.2861H6V18.2861H0ZM3.36749 12.3017C1.35508 13.5248 0 15.7458 0 18.2861H6C6 17.9272 6.18716
           17.6093 6.48359 17.4291L3.36749 12.3017ZM3.73574 11.5013C2.96368 12.1563 2.40982 12.974 2.09469
           13.8723L7.75639 15.8585C7.73848 15.9096 7.71423 15.9568 7.68623 15.9975C7.65803 16.0385 7.63206
           16.064 7.6176 16.0763L3.73574 11.5013Z"
          fill="white"
          mask="url(#path-4-outside-1_6520_14119)"
        />
        <rect
          x="4"
          y="15.4238"
          width="30"
          height="21"
          rx="3"
          fill="white"
          stroke="#777677"
          strokeWidth="2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.67667 14.781L17.103 5.08591C18.036 4.29428 19.4049 4.29428 20.3379 5.08591L31.7642 14.781C32.5985
          15.4888 32.8052 16.505 32.5482 17.3832C32.8051 18.2613 32.5984 19.2774 31.7641 19.9852L20.3378
          29.6802C19.4048 30.4719 18.0359 30.4719 17.1029 29.6802L5.67662 19.9852C4.84235 19.2773 4.63564 18.2611
          4.89263 17.383C4.63572 16.5049 4.84246 15.4888 5.67667 14.781Z"
          fill="#C7C7C7"
        />
        <path
          d="M17.103 5.08591L17.75 5.84842V5.84842L17.103 5.08591ZM5.67667 14.781L6.32365 15.5435L5.67667
          14.781ZM20.3379 5.08591L20.9848 4.32341V4.32341L20.3379 5.08591ZM31.7642 14.781L31.1172
          15.5435H31.1172L31.7642 14.781ZM32.5482 17.3832L31.5884 17.1023L31.5062 17.3831L31.5884 17.664L32.5482
          17.3832ZM31.7641 19.9852L32.4111 20.7477L31.7641 19.9852ZM20.3378 29.6802L19.6908 28.9177L20.3378
          29.6802ZM17.1029 29.6802L17.7499 28.9177L17.1029 29.6802ZM5.67662 19.9852L5.02964 20.7477H5.02964L5.67662
          19.9852ZM4.89263 17.383L5.85238 17.6639L5.93457 17.383L5.8524 17.1022L4.89263 17.383ZM16.456 4.32341L5.02969
          14.0185L6.32365 15.5435L17.75 5.84842L16.456 4.32341ZM20.9848 4.32341C19.6786 3.21512 17.7622 3.21511 16.456
          4.32341L17.75 5.84842C18.3098 5.37344 19.1311 5.37344 19.6909 5.84842L20.9848 4.32341ZM32.4112 14.0185L20.9848
           4.32341L19.6909 5.84842L31.1172 15.5435L32.4112 14.0185ZM33.5079 17.664C33.8649 16.4441 33.5751 15.0061
           32.4112 14.0185L31.1172 15.5435C31.6218 15.9716 31.7454 16.5659 31.5884 17.1023L33.5079 17.664ZM32.4111
           20.7477C33.575 19.7602 33.8648 18.3222 33.5079 17.1024L31.5884 17.664C31.7453 18.2003 31.6217 18.7946
           31.1172 19.2227L32.4111 20.7477ZM20.9848 30.4427L32.4111 20.7477L31.1172 19.2227L19.6908 28.9177L20.9848
           30.4427ZM16.456 30.4427C17.7622 31.551 19.6786 31.551 20.9848 30.4427L19.6908 28.9177C19.131 29.3927
           18.3097 29.3927 17.7499 28.9177L16.456 30.4427ZM5.02964 20.7477L16.456 30.4427L17.7499 28.9177L6.32359
           19.2227L5.02964 20.7477ZM3.93289 17.1021C3.57587 18.322 3.86568 19.7601 5.02964 20.7477L6.32359
           19.2227C5.81902 18.7945 5.6954 18.2002 5.85238 17.6639L3.93289 17.1021ZM5.02969 14.0185C3.86581 15.006
           3.57596 16.4439 3.93287 17.6638L5.8524 17.1022C5.69547 16.5658 5.8191 15.9716 6.32365 15.5435L5.02969
           14.0185Z"
          fill="#777677"
        />
        <path
          d="M18.3694 23.9362L5.18599 34.6477C4.45528 35.2414 4.87509 36.4238 5.81658 36.4238H32.1834C33.1249 36.4238
          33.5447 35.2414 32.814 34.6477L19.6306 23.9362C19.2632 23.6377 18.7368 23.6377 18.3694 23.9362Z"
          fill="white"
          stroke="#777677"
          strokeWidth="2"
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="28"
      viewBox="0 0 41 28"
      fill="none"
    >
      <mask
        id="path-1-outside-1_6144_11195"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="41"
        height="28"
        fill="black"
      >
        <rect fill="white" width="41" height="28" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 7C3 4.79086 4.79086 3 7 3H34C36.2091 3 38 4.79086 38 7V21C38 23.2091
          36.2091 25 34 25H7C4.79086 25 3 23.2091 3 21V7Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 7C3 4.79086 4.79086 3 7 3H34C36.2091 3 38 4.79086 38 7V21C38 23.2091 36.2091
        25 34 25H7C4.79086 25 3 23.2091 3 21V7Z"
        fill="#5BA9F9"
      />
      <path
        d="M7 0C3.13401 0 0 3.13401 0 7H6C6 6.44772 6.44772 6 7 6V0ZM34 0H7V6H34V0ZM41
        7C41 3.13401 37.866 0 34 0V6C34.5523 6 35 6.44771 35 7H41ZM41 21V7H35V21H41ZM34
        28C37.866 28 41 24.866 41 21H35C35 21.5523 34.5523 22 34 22V28ZM7 28H34V22H7V28ZM0
        21C0 24.866 3.13401 28 7 28V22C6.44772 22 6 21.5523 6 21H0ZM0 7V21H6V7H0Z"
        fill="white"
        mask="url(#path-1-outside-1_6144_11195)"
      />
      <path
        d="M4 7.92383C4 6.26697 5.34315 4.92383 7 4.92383H34C35.6569 4.92383 37 6.26697 37
        7.92383V20.9238C37 22.5807 35.6569 23.9238 34 23.9238H7C5.34315 23.9238 4 22.5807
        4 20.9238V7.92383Z"
        fill="#5BA9F9"
        stroke="#402555"
        strokeWidth="2"
      />
      <path
        d="M19.8811 11.4114L6.2662 22.1383C5.52076 22.7257 5.93607 23.9238 6.88507
        23.9238H34.1149C35.0639 23.9238 35.4792 22.7257 34.7338 22.1383L21.1189
        11.4114C20.7559 11.1254 20.2441 11.1254 19.8811 11.4114Z"
        fill="#7FC8FC"
        stroke="#402555"
        strokeWidth="2"
      />
      <path
        d="M20.9209 17.2076L34.5491 6.60786C35.6765 5.73101 35.0564 3.92383 33.6282
        3.92383L6.3718 3.92383C4.94357 3.92383 4.32351 5.731 5.45089 6.60785L19.0791
        17.2076C19.6208 17.6289 20.3792 17.6289 20.9209 17.2076Z"
        fill="#C1E6FE"
        stroke="#402555"
        strokeWidth="2"
      />
    </svg>
  );
};
